module.exports = __webpack_public_path__ + "static/media/291357.a69a6dea.png";